import { Icon } from '@iconify/react';
import { Button } from '@/components/shadcn/button';

interface BadmintonCompactStepperProps {
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
  label: string;
}

export default function BadmintonCompactStepper({
  value,
  min,
  max,
  onChange,
  label,
}: BadmintonCompactStepperProps) {
  return (
    <div className="flex items-center gap-2" aria-label={label}>
      <Button
        type="button"
        variant="outline"
        size="icon"
        aria-label={`Kurangi ${label}`}
        disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        className="h-8 w-8 rounded-full border-gray-200 text-gray-500"
      >
        <Icon icon="mdi:minus" className="h-4 w-4" />
      </Button>
      <span className="min-w-6 text-center text-base font-extrabold text-[#0E1726]">{value}</span>
      <Button
        type="button"
        size="icon"
        aria-label={`Tambah ${label}`}
        disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        className="h-8 w-8 rounded-full bg-[#FFF1EC] text-[#FC480D] hover:bg-[#FFE4D8]"
      >
        <Icon icon="mdi:plus" className="h-4 w-4" />
      </Button>
    </div>
  );
}
